import React from "react";
import "../../Styles/DashboardSidebar.css";

const DashboardSidebar = ({ setActive }) => {
  return (
    <div className="DashboardSidebar">
      <div className="DashboardSidebar_header">
        <h1>ExpertHouseTechnology</h1>
        {/* ======================  */}
      </div>
      <li onClick={() => setActive(1)}>Change Hero Content</li>
      <li onClick={() => setActive(2)}>Contact-Us</li>
      {/* ============  */}
    </div>
  );
};

export default DashboardSidebar;
